interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  label?: string;
}

const sizeClasses = {
  sm: 'h-4 w-4 border-2',
  md: 'h-8 w-8 border-2',
  lg: 'h-12 w-12 border-[3px]',
};

export default function Spinner({ size = 'md', label }: SpinnerProps) {
  return (
    <div className="flex flex-col items-center justify-center gap-3" role="status">
      <div
        className={`${sizeClasses[size]} animate-spin rounded-full border-kromeka-gray/30 border-t-kromeka-red`}
        aria-hidden
      />
      {label && <p className="text-sm text-text-muted">{label}</p>}
    </div>
  );
}
